<div class="activity-parent" (scroll)="calcInfiniteScroll()">
  <div class="activity" #activity>
    <h1>Asset Activity</h1>
    <!-- </ng-container> -->
    @if (!loading && !days.length) {
      <div class="no-activity">
        <img src="/assets/icons/special/bolt-dotted-disabled.svg" alt="" />
      </div>
    }
    @for (day of days; track day) {
      <div class="day">
        @for (group of day.activityGroups; track group) {
          @if (group.link) {
            <a [routerLink]="group.link" [queryParams]="group.queryParams" [fragment]="group.fragment">
              <app-activity-group [group]="group" [day]="day" [seen]="isSeen(group)" [small]="true" [context]="'asset'">
              </app-activity-group>
            </a>
          }
          @if (!group.link) {
            <app-activity-group
              [group]="group"
              [day]="day"
              [seen]="isSeen(group)"
              (click)="clickGroup(group)"
              [small]="true"
            >
            </app-activity-group>
          }
        }
      </div>
    }
    @if (loading) {
      <div class="loader">
        <app-loading-indicator></app-loading-indicator>
      </div>
    }
  </div>
</div>
